import React, {useState} from "react";
import './Register.css';
import UserPool from "../../UserPool";

function Register(){
    const[formData, setFormData] = useState({
        name: "",
        email: "",
        password: ""
    });
    const [error, setError] = useState("")
    const handleSubmit = (event) => {
        event.preventDefault();
        UserPool.signUp(formData.email, formData.password, [], null, (err, data) => {
            if(err) {
                console.error(err);
                setError(err.message.split(":").pop())
            }
            else {
                setError("Sign-Up was a Success! Please Log-In.")
            }
            console.log(data);
        })
    }

    function handleChange(event) {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    }
    return(
        // body
        <div>
            {/* top bar */}
            <div className="top-bar">
                <div className="logo-container">
                    <img src='/images/notable-logo.png'  height="50" alt='notable-logo'/>
                </div>
            </div>
            <div>
                {/* left side */}
                <div className="login-image-container">
                    <img src='/images/signup-photo.png'  height="100%"/>
                </div>
                {/* right side */}
                <div className="form-container">
                    <div className="form-box">
                        <h2 className="header1-register">Let's Get You Started!</h2>
                        <p className="header2-register">Create Your Account Here.</p>
                        <form className="login-form" onSubmit={handleSubmit}>
                            <input
                                name="name"
                                type="text"
                                placeholder="Name"
                                onChange={handleChange}
                                value={formData.name}
                            />
                            <br />
                            <input
                                name="email"
                                className="email"
                                type="email"
                                placeholder="Email"
                                onChange={handleChange}
                                value={formData.email}
                            />
                            <br />
                            <input
                                name="password"
                                type="password"
                                placeholder="Password"
                                onChange={handleChange}
                                value={formData.password}
                            />
                            <br />
                            <button type="submit">Sign Up</button>
                            <br />
                            {error ? <label style={{color:'red'}}>{error}</label> : null}
                        </form>
                        <div className="sign-up-redirect">
                            <div className="header3-register">
                                <h4 >Already have an account? &nbsp;</h4>
                            </div>
                            <div className="log-in-redirect-button-container">
                                <a className='log-in-redirect-button' href="/">Log In</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
export default Register;
